function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104.85 -104.85000000000001) scale(2.33 2.33)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 45 0 C 20.147 0 0 20.147 0 45 c 0 24.853 20.147 45 45 45 s 45 -20.147 45 -45 C 90 20.147 69.853 0 45 0 z M 40.269 41.74 h 9.462 c 4.283 0 7.769 3.485 7.769 7.769 v 7.341 c 0 4.284 -3.485 7.77 -7.769 7.77 H 48 v 5.502 h -6 v -5.502 h -1.731 c -4.284 0 -7.769 -3.485 -7.769 -7.77 h 6 c 0 0.959 0.81 1.77 1.769 1.77 h 9.462 c 0.959 0 1.769 -0.811 1.769 -1.77 v -7.341 c 0 -0.959 -0.81 -1.769 -1.769 -1.769 h -9.462 v -0.001 c -4.284 0 -7.769 -3.485 -7.769 -7.769 V 32.63 c 0 -4.284 3.485 -7.769 7.769 -7.769 H 42 v -5.502 h 6 v 5.502 h 1.731 c 4.283 0 7.769 3.485 7.769 7.769 h -6 c 0 -0.959 -0.81 -1.769 -1.769 -1.769 h -9.462 c -0.959 0 -1.769 0.81 -1.769 1.769 v 7.341 C 38.5 40.93 39.31 41.74 40.269 41.74 z",
  transform: " matrix(1 0 0 1 0 0) ",
  strokeLinecap: "round"
}));

var SvgSalary = function SvgSalary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(1.21 1.21)",
    style: {}
  }, _ref2));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salary.4f0db216.svg";
export { ForwardRef as ReactComponent };